import { useContext } from "react";
import { AppContext } from "../Contexts";
export function useApp() {
    const { configuration } = useContext(AppContext);
    return {
        configuration,
    };
}
